// import React from 'react';
// import { CirclePie } from 'salad-ui.chart';
// // import { Container } from 'mdbreact';
// import { Chart } from 'react-chartjs-2';
// import '../css/PieChart.css';
// import totalDevices from '../assets/images/totalDevices.svg';

// // PieChart page old implementation

// class PieChart extends React.Component {
//     constructor(props) {
//         super(props);    
//         this.state = {
//           labelFontSize: this.props.percentLabelSize || '1rem',
//           percentFontSize: this.props.percentFontSize || '4rem',
//           percentTop : this.props.percentTop || "24%",
//           percentLabelTop : this.props.percentLabelTop || "62%"
//         };
//       }
//     componentDidMount() {
//         //doughnut
//         var ctxD = document.getElementById("doughnutChart").getContext('2d');
//         new Chart(ctxD, {
//             type: 'doughnut',
//             data: {
//                 labels: ["Red", "Green", "Yellow", "Grey", "Dark Grey"],
//                 datasets: [
//                     {
//                         data: [300, 50, 100, 40, 120],
//                         backgroundColor: ["#F7464A", "#46BFBD", "#FDB45C", "#949FB1", "#4D5360"],
//                         hoverBackgroundColor: ["#FF5A5E", "#5AD3D1", "#FFC870", "#A8B3C5", "#616774"]
//                     }
//                 ]
//             },
//             options: {
//                 responsive: true
//             }
//         });
//     }
//     render() {
//         return (
//             <div className="text-center alignCircleItems">
//             <div className="alignDisplayOverCircle">
//              <CirclePie strokeWidth={this.props.strokeWidth || 8} percent={this.props.percent} width={this.props.chartWidth} height={this.props.chartWidth} strokeColor={this.props.strokeColor || "#43425d" }  label="asd"/>              
//              <div className="displayCircle" style={{top: this.state.percentTop}}>
//              <span className="some-text" style={{backgroundColor: this.props.displayBackgroundColor, fontSize: this.state.percentFontSize}}>
//              {this.props.percent}
//              </span>
//              </div>
//              <div className="displayCircleSubHeading text-center" style={{fontSize: this.state.labelFontSize, top: this.state.percentLabelTop }}>{this.props.percentLabel}</div>
//              </div>          
//              <h6 className="mt-2">
//              <span className={`${this.props.icon}`}/><div className="text-center">{this.props.label}</div>    
//              </h6>        
//         </div>
//         );
//     }

// };

// export default PieChart;


import React from 'react';
import { CirclePie } from 'salad-ui.chart';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import '../css/PieChart.css';
import totalDevices from '../assets/images/totalDevices.svg';

// ✅ Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

class PieChart extends React.Component {
    constructor(props) {
        super(props);    
        this.state = {
            labelFontSize: this.props.percentLabelSize || '1rem',
            percentFontSize: this.props.percentFontSize || '4rem',
            percentTop: this.props.percentTop || "24%",
            percentLabelTop: this.props.percentLabelTop || "62%"
        };
    }

    render() {
        // ✅ Replace manual chart creation with Doughnut component
        const data = {
            labels: ["Red", "Green", "Yellow", "Grey", "Dark Grey"],
            datasets: [
                {
                    data: [300, 50, 100, 40, 120],
                    backgroundColor: ["#F7464A", "#46BFBD", "#FDB45C", "#949FB1", "#4D5360"],
                    hoverBackgroundColor: ["#FF5A5E", "#5AD3D1", "#FFC870", "#A8B3C5", "#616774"]
                }
            ]
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
        };

        return (
            <div className="text-center alignCircleItems">
                <div className="alignDisplayOverCircle">
                    <CirclePie 
                        strokeWidth={this.props.strokeWidth || 8} 
                        percent={this.props.percent} 
                        width={this.props.chartWidth} 
                        height={this.props.chartWidth} 
                        strokeColor={this.props.strokeColor || "#43425d" }  
                        label="asd"
                    />
                    <div className="displayCircle" style={{top: this.state.percentTop}}>
                        <span className="some-text" 
                            style={{backgroundColor: this.props.displayBackgroundColor, fontSize: this.state.percentFontSize}}>
                            {this.props.percent}
                        </span>
                    </div>
                    <div className="displayCircleSubHeading text-center" 
                        style={{fontSize: this.state.labelFontSize, top: this.state.percentLabelTop }}>
                        {this.props.percentLabel}
                    </div>
                </div>

                {/* ✅ Fixed: Use Doughnut component */}
                <div style={{ width: "300px", height: "300px", margin: "auto" }}>
                    <Doughnut data={data} options={options} />
                </div>

                <h6 className="mt-2">
                    <span className={`${this.props.icon}`} />
                    <div className="text-center">{this.props.label}</div>    
                </h6>
            </div>
        );
    }
}

export default PieChart;
